import React from 'react';
import DatePicker from 'material-ui/DatePicker';
import { fromUTC, localToUTC, makeLocalAppearUTC } from 'helpers/dates';
import moment from 'moment';
import IconButton from 'material-ui/IconButton';
import RemoveCircle from 'material-ui/svg-icons/content/remove-circle-outline';

export default function RangeDates({ from, until, changeDateRange, handleChangeDate }) {
    const maxDate = new Date();
    return (
        <div style={{ display: 'flex' }}>
            <DatePicker 
                floatingLabelText='Filter start date:'
                autoOk
                maxDate={until ? makeLocalAppearUTC(new Date(until)) : maxDate}
                textFieldStyle={{ width: '120px' }}
                onChange={(_, date) => changeDateRange('from', moment(date).utcOffset(0, true))}
                value={from ? makeLocalAppearUTC(from) : undefined}
            />
            <IconButton
                style={{ margin: '25px 7px 0 -7px' }}
                disabled={!from}
                onClick={() => handleChangeDate('from', null)}
            >
                <RemoveCircle 
                    color={from ? 'red' : 'black'}
                />
            </IconButton>
            <DatePicker 
                style={{ marginLeft: '15px' }}
                floatingLabelText='Filter end date:'
                autoOk
                minDate={from ? new Date(from) : undefined}
                textFieldStyle={{ width: '120px' }}
                onChange={(_, date) => {
                    return changeDateRange('until', moment(localToUTC(date)).utcOffset(0, true).set({ hour: 23, minute: 59, second: 59 }));
                }}
                value={until ? makeLocalAppearUTC(until) : undefined}
            />
            <IconButton
                style={{ margin: '25px 7px 0 -7px' }}
                disabled={!until}
                onClick={() => handleChangeDate('until', null)}
            >
                <RemoveCircle 
                    color={until ? 'red' : 'black'}
                />
            </IconButton>
        </div>
    );
}



// WEBPACK FOOTER //
// ./app/components/Analytics/RangeDates.jsx